import { componentName, TextClass } from './TextClass';

customElements.define(componentName, TextClass);

export { TextClass, componentName };
